(ns app.survey.login.email.event
  (:require
   [ajax.core :as ajax]
   [app.survey.event :as app-event]
   [app.survey.login.email.state :as state]
   [app.survey.login.email.sub :as sub]
   [app.survey.sub :as app-sub]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [re-frame.core :as rf]
   [ui.components.alert-list.event :as alert-list-event]))

(rf/reg-event-fx
 ::edit-email-token
 (fn [{db :db} [_ token-text]]
   {:db (-> db
            (assoc ::sub/email-token token-text))}))

(rf/reg-event-fx
 ::cancel-login-process
 (fn [{db :db} _]
   {:db         (assoc db ::sub/state ::state/logging-out)
    :http-xhrio {:method          :post
                 :uri             "/login/api/logout"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::app-event/logout]
                 :on-failure      [::app-event/on-logout-failed]}}))

(rf/reg-event-fx
 ::submit-email-token-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login submit EMAIL token failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/sent-email-token))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      5000
            :variant         :danger
            :message-content [:div
                              (str (get-in err [:response :message]))]}]]]}))

(rf/reg-event-fx
 ::submit-email-token-ok
 (fn [{db :db} [_ resp]]
   (let [ok-or-tries-left (:body resp)
         ok? (= ok-or-tries-left :ok)
         new-state (cond ok?
                         ::state/auth-ok
                         :else
                         ::state/sent-email-token)
         tries-left (if (number? ok-or-tries-left)
                      ok-or-tries-left
                      5)]
     (js/console.log "Submit email token ok : " resp)
     (merge {:db (-> db
                     (assoc ::sub/state new-state)
                     (assoc ::sub/tries-left tries-left))}
            (if ok?
              {:fx [[:dispatch [::app-event/load-app-config true]]]}
              {:fx [[:dispatch
                     [::alert-list-event/add-alert
                      {:list-id         :login-notifications
                       :hide-in-ms      3000
                       :variant         :danger
                       :message-content [:div
                                         (loc/tr :could-not-verify-email-token)]}]]]})))))

(rf/reg-event-fx
 ::submit-email-token
 (fn [{db :db} _]
   (let [token (get db ::sub/email-token)]
     {:db         (-> db
                      (assoc ::sub/state ::state/sent-email-token))
      :http-xhrio {:method          :post
                   :uri             "/login/api/submit-email-token"
                   :params          {:email-token token}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::submit-email-token-ok]
                   :on-failure      [::submit-email-token-failed]}})))

(rf/reg-event-fx
 ::init
 (fn [{db :db}]
   (let [masked-email (get db ::app-sub/invited-email)
         new-state ::state/sent-email-token]
     (js/console.log "Init " new-state " << " masked-email)
     {:db (-> db
              (assoc ::sub/state new-state
                     ::sub/masked-email masked-email))})))

(rf/reg-event-fx
 ::send-email-token-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login send verification email failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/sent-email-token))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      3000
            :variant         :danger
            :message-content [:div
                              (loc/tr :could-not-send-email)]}]]]}))

(rf/reg-event-fx
 ::send-email-token-ok
 (fn [{db :db} [_ resp]]
   (let [ok (some->> resp
                     :body
                     (= :ok))
         new-state ::state/sent-email-token]
     {:db (-> db
              (assoc ::sub/state new-state))})))

(rf/reg-event-fx
 ::send-email-token
 (fn [{db :db}]
   {:db         (-> db
                    (assoc ::sub/state ::state/submitting-email-token))
    :http-xhrio {:method          :post
                 :uri             "/login/api/send-verification-email"
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::send-email-token-ok]
                 :on-failure      [::send-email-token-failed]}}))
